/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { TypeLatLng } from './TypeLatLng';
import {
    TypeLatLngFromJSON,
    TypeLatLngFromJSONTyped,
    TypeLatLngToJSON,
} from './TypeLatLng';

/**
 * 
 * @export
 * @interface V1LocalProfileReviewCommentary
 */
export interface V1LocalProfileReviewCommentary {
    /**
     * 
     * @type {string}
     * @memberof V1LocalProfileReviewCommentary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof V1LocalProfileReviewCommentary
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof V1LocalProfileReviewCommentary
     */
    localProfileName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof V1LocalProfileReviewCommentary
     */
    imagesUrls: Array<string>;
    /**
     * 
     * @type {TypeLatLng}
     * @memberof V1LocalProfileReviewCommentary
     */
    latlng: TypeLatLng;
}

/**
 * Check if a given object implements the V1LocalProfileReviewCommentary interface.
 */
export function instanceOfV1LocalProfileReviewCommentary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "localProfileName" in value;
    isInstance = isInstance && "imagesUrls" in value;
    isInstance = isInstance && "latlng" in value;

    return isInstance;
}

export function V1LocalProfileReviewCommentaryFromJSON(json: any): V1LocalProfileReviewCommentary {
    return V1LocalProfileReviewCommentaryFromJSONTyped(json, false);
}

export function V1LocalProfileReviewCommentaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1LocalProfileReviewCommentary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'localProfileName': json['local_profile_name'],
        'imagesUrls': json['images_urls'],
        'latlng': TypeLatLngFromJSON(json['latlng']),
    };
}

export function V1LocalProfileReviewCommentaryToJSON(value?: V1LocalProfileReviewCommentary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'content': value.content,
        'local_profile_name': value.localProfileName,
        'images_urls': value.imagesUrls,
        'latlng': TypeLatLngToJSON(value.latlng),
    };
}

